$('.home-banner-block-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  autoplay: true,
  autoplaySpeed: 5000,        // <- no delay
  speed: 600,             // <- smooth transition speed
  arrows: true,
  dots: false,
  pauseOnHover: false,
});
